import React from "react";

/**
 * NewsroomOverlayRender — renders broadcaster-sent newsroom overlays as absolute
 * DOM layers on top of the stream video. Used by both StreamViewer (remote) and
 * AdvancedDirectorPanel (host preview) for visual parity.
 *
 * Overlay shape:
 *   {
 *     lower_third: {visible, name, title, accent},
 *     breaking:    {visible, text},
 *     ticker:      {visible, text, speed},
 *     pip:         {visible, label}   // decorative — PIP video itself is host-local
 *   }
 */
export default function NewsroomOverlayRender({ overlays }) {
  const ov = overlays || {};
  return (
    <>
      {ov.lower_third?.visible && (
        <div data-testid="overlay-lower-third" className="absolute bottom-16 left-4 z-30 max-w-[70%] bg-gradient-to-r from-tv-accent to-yellow-500 text-black rounded-r-md px-5 py-2.5 shadow-lg">
          <div className="text-[10px] uppercase tracking-[0.25em] font-bold opacity-80">Tap IN TV · Live</div>
          <div className="font-display font-black text-lg leading-tight">{ov.lower_third.name || ""}</div>
          {ov.lower_third.title && <div className="text-xs font-semibold opacity-90">{ov.lower_third.title}</div>}
        </div>
      )}
      {ov.breaking?.visible && (
        <div data-testid="overlay-breaking" className="absolute top-12 left-0 right-0 z-30 bg-tv-live text-white px-4 py-2 flex items-center gap-3 shadow-lg">
          <span className="text-[10px] uppercase tracking-[0.25em] font-black bg-white text-tv-live px-2 py-0.5 rounded">Breaking</span>
          <div className="font-display font-bold text-sm sm:text-base truncate flex-1">{ov.breaking.text || ""}</div>
        </div>
      )}
      {ov.ticker?.visible && ov.ticker.text && (
        <div data-testid="overlay-ticker" className="absolute bottom-0 left-0 right-0 z-30 bg-black/85 text-white overflow-hidden">
          <div className="flex whitespace-nowrap py-1.5 animate-[ticker_40s_linear_infinite]" style={{ animationDuration: `${Math.max(20, 60 - (ov.ticker.speed || 0))}s` }}>
            <span className="px-6 font-display font-bold text-sm">{ov.ticker.text}</span>
            <span className="px-6 font-display font-bold text-sm" aria-hidden>{ov.ticker.text}</span>
            <span className="px-6 font-display font-bold text-sm" aria-hidden>{ov.ticker.text}</span>
          </div>
        </div>
      )}
    </>
  );
}
